import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { Collection } from 'src/app/modules/admin/models';
import { ResidencyJurisdiction } from 'src/app/modules/admin/models/residency-jurisdiction';
import { ResidencyJurisdictionService } from 'src/app/modules/admin/services';

@Component({
  standalone: false,
  selector: 'gstar-residency-jurisdiction-combobox',
  templateUrl: './residency-jurisdiction-combobox.component.html',
  styleUrls: ['./residency-jurisdiction-combobox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResidencyJurisdictionComboboxComponent implements OnInit {
  private readonly residencyJurisdictionService = inject(
    ResidencyJurisdictionService
  );

  resJurisdictions: WritableSignal<ResidencyJurisdiction[]> = signal<
    ResidencyJurisdiction[]
  >([]);

  @Input() value!: ResidencyJurisdiction | null | undefined;
  @Input() disabled?: boolean;
  @Input() required?: boolean;

  @Output() selectResidencyJurisdiction: EventEmitter<
    ResidencyJurisdiction | null | undefined
  > = new EventEmitter();

  ngOnInit(): void {
    this.residencyJurisdictionService
      .get({ filter: { isActive: true } })
      .subscribe((response: Collection<ResidencyJurisdiction>) => {
        this.resJurisdictions.set(cloneDeep(response.items));
      });
  }

  selectResidencyJurisdictionHandler(
    residencyJurisdiction: ResidencyJurisdiction | null | undefined
  ): void {
    if (residencyJurisdiction)
      this.residencyJurisdictionService.selectResidencyJurisdiction(
        residencyJurisdiction
      );
    this.value = residencyJurisdiction;
    this.selectResidencyJurisdiction.emit(residencyJurisdiction);
  }
}
